module.exports = fox._r("images/bg/bi-join-banner.jpg", __webpack_public_path__ + "images/bg/bi-join-banner.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/bi-join-banner.jpg
// module id = 1005
// module chunks = 4